export default {
    //temp states
	hasPerformedInitialLoad: false,
	isAuthorized: false,
	isWaitingForWhoami: false,
	isWaitingForSocket: false,
	authToken: '',
	displayName: '',

	products: {
		a:{
			user_id: 1,
			price: '45',
			images: [
				218197624,
				218197626,
				218197627
			]
		},
		b:{
			user_id: 1,
			price: '3250',
			images: [
				221087355
			]
		},
		c:{
			user_id: 1,
			price: '2000',
			images: [
				220961029
			]
		},
		d:{
			user_id: 1,
			price: '800',
			images: [
				221703303,
				221703306,
				221703307,
				221703308
			]
		}
	},
	searchScroll: 0,
	searchQuery: '',
	searchProducts: ['a','b','c','d'],
	nextSearchPage: false,
	localSearchPage: 1,
	spinTokens: false,

	//Flyt til ux efter rebase
	popupPrompt: {
		title: '',
		prompt: '',
		callback: false,
		confirmText: 'Ja',
		denyText: 'Nej',
		showCancelButton: true
	},

	//socket data
	rooms: {},
	currentRoom: false,
	kraemmerData: {},
	notification: ''
};
